export class Dropdown {
	dropdownItemList: NodeList = document.querySelectorAll("[data-dropdown]");
	dropdownItemListArray: HTMLElement[] = Array.prototype.slice.call(this.dropdownItemList);
	dropdownItemHeaderList: NodeList = document.querySelectorAll("[data-dropdown-header]");
	dropdownItemArray: HTMLElement[] = Array.prototype.slice.call(this.dropdownItemHeaderList);
	dropdownItemContentList: NodeList = document.querySelectorAll("[data-dropdown-close-on-click] [data-dropdown-content]");
	dropdownItemContentArray: HTMLElement[] = Array.prototype.slice.call(this.dropdownItemContentList);
	dropdownItemContentSetHeaderList: NodeList = document.querySelectorAll("[data-dropdown-set-header] [data-dropdown-content] li");
	dropdownItemContentSetHeaderArray: HTMLElement[] = Array.prototype.slice.call(this.dropdownItemContentSetHeaderList);

	activeClass: string = 'is-active';

	constructor() {
		this.toggleDropdownContent()
		this.onclickHandler()
		this.setHeaderValue()
	}

	private toggleDropdownContent = () => {
		this.dropdownItemArray.forEach((elem) => {
			elem.addEventListener("click", () => {
				if (!elem.parentElement.classList.contains(this.activeClass)) {
					// add active class to clicked, and remove from other
					this.removeActiveHelper();
					elem.parentElement.classList.add(this.activeClass);
				} else {
					// toggle active class on clicked elm
					elem.parentElement.classList.remove(this.activeClass);
				}
			});
		});
	}
	private removeActiveHelper = () => {
		// remove active class helper
		this.dropdownItemListArray.forEach((test) => {
			test.classList.remove(this.activeClass);
		});
	}
	private onclickHandler = () => {
		// Close dropdown, when child element is clicked
		this.dropdownItemContentArray.forEach((elem) => {
			elem.addEventListener("click", () => {
				elem.parentElement.classList.remove(this.activeClass);
			});
		});
	}
	// set header on click
	private setHeaderValue = () => {
		this.dropdownItemContentSetHeaderArray.forEach((elem) => {
			elem.addEventListener("click", () => {
				const clickedVal = elem.innerText;
				let getParent = elem.parentElement.parentElement.parentElement;
				let getParentHeader = getParent.firstElementChild.firstElementChild as HTMLElement;
				getParentHeader.innerText = clickedVal;
			});
		});
	}
}